import { ResetIcon } from "./icons/ResetIcon";

const ResetButton = (props) => {
  return (
    <div
      style={{
        position: "relative",
        width: "55px",
        height: "55px",
        border: "5px solid black",
        borderRadius: "10px",
        marginLeft: "5px",
        cursor: "pointer",
      }}
      {...props}
    >
      <ResetIcon />
    </div>
  );
};

export { ResetButton };
